import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ReimbursementDetailsContent } from "./ReimbursementDetailsContent";
import { useEffect, useState } from "react";
import { ReportSelectionContent } from "./ReportSelectionContent";
import { z } from "zod";
import { useCustomFieldFormConfig } from "@common/components/CustomFields";
import { expenseFormSchemaObject } from "../forms/Forms";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateReimbursementSheet = ({ isOpen, onClose }: Props) => {
  const { customFieldSchema, customFieldDefaultValues } =
    useCustomFieldFormConfig();
  const schema = z.object({
    ...expenseFormSchemaObject,
    ...customFieldSchema,
  });

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });
  const [step, setStep] = useState(0);

  useEffect(() => {
    form.reset({
      id: undefined,
      merchant: undefined,
      expenseCategoryGLId: undefined,
      amount: undefined,
      date: undefined,
      notes: undefined,
      receipt: undefined,
      reportId: undefined,
      attendeeEmails: undefined,
      ...customFieldDefaultValues,
    });
    setStep(0);
  }, [isOpen, form, customFieldDefaultValues]);

  const handleClose = () => onClose();
  const nextStep = () => {
    form.reset(form.getValues());
    setStep(step + 1);
  };
  const prevStep = () => setStep(step - 1);

  return (
    <Sheet open={isOpen}>
      <SheetContent className="flex grow flex-col" onClose={handleClose}>
        {step === 0 && (
          <ReimbursementDetailsContent form={form} nextStep={nextStep} />
        )}
        {step === 1 && (
          <ReportSelectionContent
            form={form}
            prevStep={prevStep}
            onComplete={handleClose}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};
